export default "<div class=\"loading-overlay\">\r\n    <app-loading-spinner></app-loading-spinner>\r\n</div>"